import { GDErrCode } from "./customErrCode";
import { type NormalizedError } from "./errorHandle";

export function handleSpaceErr(error: NormalizedError) {
  const { code } = error;

  if (code === GDErrCode.SpaceFull) {
    error.message = error.msg =
      "保存失败，空间容量已满，请清理空间后从下载记录中重新保存";
  }
}
